import { gql } from '@apollo/client'
import MEDICAL_NAVIGATION_TYPE_FRAGMENT from 'apollo/fragments/MEDICAL_NAVIGATION_TYPE_FRAGMENT'
import { useSafeRunMutation } from 'utils/mutations'

// MEDICAL_NAVIGATION_UPDATE

const mutation = gql`
  mutation medicalNavigationUpdate(
    $id: ID!
    $medical_navigation: UpdateMedicalNavigationAttributesInput
  ) {
    medicalNavigationUpdate(id: $id, medical_navigation: $medical_navigation) {
      ...MEDICAL_NAVIGATION_TYPE_FRAGMENT
    }
  }
  ${MEDICAL_NAVIGATION_TYPE_FRAGMENT}
`

export default function useMedicalNavigationUpdate(
  successMessage = 'Medical Navigation updated'
) {
  const { onMutate: onMedicalNavigationUpdate, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'medicalNavigationUpdate'
  })
  return { onMedicalNavigationUpdate, loading }
}
